import { render, staticRenderFns } from "./messages-list.vue?vue&type=template&id=7495bc1e&"
import script from "./messages-list.vue?vue&type=script&lang=js&"
export * from "./messages-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports